import { Entity } from '@core/entities/entity'
import { IRegisterScheduleInspectionsSchedulingConfig } from './IRegisterScheduleInspectionsSchedulingConfig'
import { RegisterItemInspectionSchedulingType } from './types'
import { plainToInstance } from 'class-transformer'

export class RegisterScheduleInspectionsSchedulingConfig extends Entity<IRegisterScheduleInspectionsSchedulingConfig> {
  checklistTemplateId: number

  excludeWeekends: boolean

  frequencyInDays: number

  isActive: boolean

  type: RegisterItemInspectionSchedulingType

  public static new(
    payload: unknown,
  ): RegisterScheduleInspectionsSchedulingConfig {
    const entity = plainToInstance(
      RegisterScheduleInspectionsSchedulingConfig,
      payload,
    )

    return entity
  }
}
